const COLORS = {
    iconColor: "gray",
    iconColor2: "#d4680b",
    mainColor: "#6232a8",
    mainColor2: "#622A0F",
  
    theBorderColor: "#6232a8",
    light: "#f7f7f7",
    light2: "#dbdbdb",
    blue: "rgb(6 30 52)",
    insideBlue: "rgb(18 43 67)",
    lightBlue:"rgb(26 115 232)",
    green: "#5cdb5c",
    red: "#ff0021",
    yellow: "#ffff00",
    
  };
  export default COLORS;